import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {UntypedFormGroup} from '@angular/forms';

@Component({
    selector: 'ngc-input-phone',
    templateUrl: './input-phone.component.html',
    styleUrls: ['./input-phone.component.scss']
})
export class InputPhoneComponent implements OnInit {

    @Input() phone: string;
    @Input() isSpinnerActive: boolean;
    @Input() formGroup: UntypedFormGroup;

    @Output() cancel = new EventEmitter<void>();
    @Output() sendCode = new EventEmitter<void>();

    constructor() {
    }

    ngOnInit(): void {
    }

    onSendCode(): void {
        this.sendCode.emit();
    }

    doCancel(): void {
        this.cancel.emit();
    }
}
